import { render, staticRenderFns } from "./NavigationItems.vue?vue&type=template&id=55e1e57b&scoped=true"
import script from "./NavigationItems.vue?vue&type=script&lang=js"
export * from "./NavigationItems.vue?vue&type=script&lang=js"
import style0 from "./NavigationItems.vue?vue&type=style&index=0&id=55e1e57b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e1e57b",
  null
  
)

export default component.exports